/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Doc_Doctor_TitleInputs */

const en_faq_doc_doctor_title = /** @type {(inputs: Faq_Doc_Doctor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seeing a Doctor Guide`)
};

const fr_faq_doc_doctor_title = /** @type {(inputs: Faq_Doc_Doctor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide pour consulter un médecin`)
};

/**
* | output |
* | --- |
* | "Seeing a Doctor Guide" |
*
* @param {Faq_Doc_Doctor_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_doc_doctor_title = /** @type {((inputs?: Faq_Doc_Doctor_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Doc_Doctor_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_doc_doctor_title(inputs)
	return fr_faq_doc_doctor_title(inputs)
});